const SET_SELECTED_TAB = "SET_SELECTED_TAB";
const OrdersSymbols = {
  SET_SELECTED_TAB,
};
export default OrdersSymbols;
